//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    countMax: {
      type: Number,
      default: 10000,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    countChange(item, count) {
      item.count = count

      this.$emit('change', item)
    },
  },
}
